import tw from "tailwind-styled-components";

export const OrderDetailsLoading = () => (
  <Container>
    <div className="flex flex-col lg:flex-row lg:flex-wrap gap-6">

      <div className="w-full order-2 lg:order-1 lg:w-full">
        <StatusSection>
          <StepperContainer>
            {[...Array(4)].map((_, i) => (
              <Step key={i}>
                <Circle />
                <Label className="w-16 mt-2" />
                {i < 3 && <Connector />}
              </Step>
            ))}
          </StepperContainer>
          <div className="mt-4 pt-4 border-t border-gray-100 flex justify-between">
            <div className="space-y-2">
              <Line className="w-40 h-4" />
              <Line className="w-60 h-3" />
            </div>
            <Line className="w-24 h-4" />
          </div>
        </StatusSection>
      </div>

      <div className="w-full order-1 lg:order-2 lg:flex-1"> {/*Order items*/}
        <Line className="w-32 h-5 mb-4" />
        <div className="space-y-3">
          {[...Array(2)].map((_, i) => (
            <ItemRow key={i}>
              <Square className="w-20 h-20" />
              <div className="flex-1 ml-4 space-y-2">
                <Line className="w-3/4 h-4" />
                <Line className="w-16 h-3" />
              </div>
              <div className="flex flex-col items-end space-y-2">
                <Line className="w-16 h-4" />
                <Line className="w-12 h-6" />
              </div>
            </ItemRow>
          ))}
        </div>
      </div>

      <div className="w-full order-3 lg:order-3 lg:w-1/3"> {/*Order summary*/}
        <Sidebar>
          <Line className="w-1/2 h-5 mb-6" />
          <div className="space-y-4">
            <div className="flex justify-between"><Line className="w-24 h-4"/><Line className="w-16 h-4"/></div>
            <div className="flex justify-between"><Line className="w-24 h-4"/><Line className="w-16 h-4"/></div>
            <div className="border-t pt-4 flex justify-between">
              <Line className="w-20 h-5 font-bold"/>
              <Line className="w-20 h-5 font-bold"/>
            </div>
          </div>
          <div className="mt-6 pt-6 border-t space-y-3">
            <Line className="w-32 h-4" />
            <Line className="w-full h-3" />
            <Line className="w-1/2 h-3" />
          </div>
        </Sidebar>
      </div>
    </div>
  </Container>
);

const Container = tw.div`animate-pulse p-5 md:px-16 md:py-8 bg-gray-50 flex-1`;
const StatusSection = tw.div`bg-white p-6 rounded-xl border border-gray-100 shadow-sm`;
const StepperContainer = tw.div`flex justify-between relative px-2`;
const Step = tw.div`flex flex-col items-center flex-1 relative`;
const Circle = tw.div`w-8 h-8 rounded-full bg-gray-200 z-10`;
const Connector = tw.div`absolute top-4 left-[50%] w-full h-[2px] bg-gray-100`;
const ItemRow = tw.div`flex items-center p-4 bg-white rounded-lg border border-gray-100 shadow-sm`;
const Sidebar = tw.div`bg-white p-6 rounded-xl border border-gray-200 shadow-sm`;
const Line = tw.div`bg-gray-200 rounded`;
const Square = tw.div`bg-gray-200 rounded-md`;
const Label = tw(Line)`h-3`;